// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_kz1","cls2":"ExportFormatModal-cls2_w70 ExportFormatModal-cls1_kz1"};